export default __webpack_public_path__ + "static/media/cats.048e99be.png";